import { useNavigate } from 'react-router-dom';
import { ACTION_TYPES, useSupplierSearchDispatch, useSupplierSearchState } from './supplier-search-context';

export const useSupplierSearchController = () => {
    const navigate = useNavigate();
    const dispatch = useSupplierSearchDispatch();
    const state = useSupplierSearchState();

    function handleOnChange(e: any) {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { term: e.target.value } });
    }

    function handleSearch() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page: 0 } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function handleClearFilters() {
        dispatch({ type: ACTION_TYPES.updateParameter, payload: { page: 0, pageSize: 100, term: undefined } });
        dispatch({ type: ACTION_TYPES.triggerSearch });
    }

    function navigateToCreate() { navigate('/fornecedores/cadastrar'); }
    function navigateToEdit(id: number) { navigate(`/fornecedores/editar/${id}`); }

    return { handleOnChange, handleSearch, handleClearFilters, navigateToCreate, navigateToEdit };
};
